/**
 *
 * Module:        Utility
 * Name:          Guru Layout Preferences
 * Description:   Persists validated Guru sidebar widths in browser storage
 * Developers:    Adrian Engelmann, Kiran Jayaramu, Nicu Bratescu, Daniela Popescu
 * Copyright:     Copyright 2026 by Qalgo GmbH (www.qalgo.de). All rights reserved.
 *
 */

export const GURU_LAYOUT_STORAGE_KEY = 'synapcusGuru.ui.v1';
export const GURU_SIDEBAR_LIMITS = {
	left: {defaultWidth: 220, minWidth: 220, maxWidth: 430},
	right: {defaultWidth: 250, minWidth: 220, maxWidth: 430}
};

const normalizeWidth = (value, limits) => {
	const width = Number(value);
	if (!Number.isFinite(width)) return limits.defaultWidth;
	return Math.min(limits.maxWidth, Math.max(limits.minWidth, Math.round(width)));
};

const normalizeExpanded = (value, defaultValue) => typeof value === 'boolean' ? value : defaultValue;

export function loadGuruLayoutPreferences(storage=window.localStorage) {
	try {
		const saved = JSON.parse(storage.getItem(GURU_LAYOUT_STORAGE_KEY) || '{}');
		return {
			leftWidth: normalizeWidth(saved.leftWidth, GURU_SIDEBAR_LIMITS.left),
			rightWidth: normalizeWidth(saved.rightWidth, GURU_SIDEBAR_LIMITS.right),
			recentExpanded: normalizeExpanded(saved.recentExpanded, true),
			filesExpanded: normalizeExpanded(saved.filesExpanded, false)
		};
	} catch {
		return {
			leftWidth: GURU_SIDEBAR_LIMITS.left.defaultWidth,
			rightWidth: GURU_SIDEBAR_LIMITS.right.defaultWidth,
			recentExpanded: true,
			filesExpanded: false
		};
	}
}

export function saveGuruLayoutPreferences({leftWidth, rightWidth, recentExpanded, filesExpanded}, storage=window.localStorage) {
	try {
		storage.setItem(GURU_LAYOUT_STORAGE_KEY, JSON.stringify({
			leftWidth: normalizeWidth(leftWidth, GURU_SIDEBAR_LIMITS.left),
			rightWidth: normalizeWidth(rightWidth, GURU_SIDEBAR_LIMITS.right),
			recentExpanded: normalizeExpanded(recentExpanded, true),
			filesExpanded: normalizeExpanded(filesExpanded, false)
		}));
	} catch {
		// Layout persistence is optional when browser storage is unavailable.
	}
}
